import { inRange } from "lodash";

export enum DashboardType {
  INVESTOR,
  ADVISOR,
  ASSOCIATE,
  PARTNER,
}

export enum SampleFilesUrls {
  SAMPLE_STOCK = "/transaction_upload/export_stock_csv/",
  SAMPLE_CASH = "/transaction_upload/export_case_csv/",
  SAMPLE_CLIENTS = "/client/export_csv/",
  SAMPLE_PORTFOLIOS = "/portfolios/export_sample_csv/",
}

export enum FetchDataURL {
  TRANSACTION = "/transaction/",
  COMPANY_MASTER_LIST = "/v1/companies/search/paged",
  PORTFOLIOS_LIST = "/portfolios/",
  CLIENTS_LIST = "/client/",
  CLIENTS_COMPLIANCE_LIST = "/client/compliance/",
  LEAD_LIST = "/lead/",
}

export enum UserRoleTypes {
  advisor = "advisor",
  client = "client",
  employee = "employee",
  partner = "partner",
  trialUser = "trial_user",
}

export enum AccountType {
  RIA = "ria",
  RA = "ra",
  RA_RIA = "ra_ria",
  ONLY_ONBOARDING = "only_onboarding",
}

export const token = localStorage.getItem(`token`);

export interface SelectOption {
  [x: string]: any;
  name: string;
  value: any;
}

export const blockInvalidChar = (e: any) =>
  ["+", "-"].includes(e.key) && e.preventDefault();

export const ignoreSpecialCharacterFn = (e: any) => {
  if (!/^[A-Za-z0-9]*$/.test(e.target.value) && !["@"].includes(e.key)) {
    e.preventDefault();
  }
};

export const handleCapitalize = (str: string) => {
  const newStr = str?.toLowerCase() || "-";

  const firstLetter = newStr?.charAt(0);

  const firstLetterCap = firstLetter?.toUpperCase();

  const remainingLetters = newStr?.slice(1);

  const capitalizedWord = firstLetterCap + remainingLetters;

  return capitalizedWord;
};

export const breakpoints = {
  xl: [993, 1284],
  lg: [769, 992],
  md: [501, 768],
  sm: [321, 500],
  xs: [0, 320],
};

export const handleGetScreenSize = (width: number) => {
  if (inRange(width, breakpoints.xl[0], breakpoints.xl[1])) {
    return "xl";
  }
  if (inRange(width, breakpoints.lg[0], breakpoints.lg[1])) {
    return "lg";
  }
  if (inRange(width, breakpoints.md[0], breakpoints.md[1])) {
    return "md";
  }
  if (inRange(width, breakpoints.sm[0], breakpoints.sm[1])) {
    return "sm";
  }

  return "xs";
};

export const occupationOptions = [
  { value: "professional", name: "Professional" },
  { value: "business", name: "Business" },
  { value: "retired", name: "Retired" },
  { value: "housewife", name: "Housewife" },
  { value: "student", name: "Student" },
  { value: "public_sector", name: "Public Sector" },
  { value: "private_sector", name: "Private Sector" },
  { value: "government_sector", name: "Government Sector" },
  { value: "others", name: "Others" },
];

export const incomeSlabOptions = [
  { value: "upto_1lakh", name: "Upto 1 Lakh" },
  { value: "above_1lakh_upto_5lakh", name: "Above 1 Lakh to 5 Lakh" },
  { value: "above_5lakh_upto_10lakh", name: "Above 5 Lakh to 10 Lakh" },
  { value: "above_10lakh_upto_25lakh", name: "Above 10 Lakh to 25 Lakh" },
  { value: "above_25lakh_upto_1cr", name: "Above 25 Lakh to 1 Crore" },
  { value: "above_1cr", name: "Above 1 Crore" },
];

export const pepDetailsOptions = [
  { value: "pep_exposed", name: "PEP Exposed" },
  { value: "pep_related", name: "PEP Related" },
  { value: "not_applicable", name: "Not Applicable" },
];
